import React from 'react';
import { Shield } from 'lucide-react';

interface SuspendedMessageBubbleProps {
  timestamp: string;
  isGrouped?: boolean;
}

const SuspendedMessageBubble: React.FC<SuspendedMessageBubbleProps> = ({
  timestamp,
  isGrouped = false
}) => {
  const formatTime = (dateString: string) => {
    const messageDate = new Date(dateString);
    const now = new Date();
    const diffInMs = now.getTime() - messageDate.getTime();
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    if (diffInMinutes < 1) {
      return 'recent';
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes}m geleden`;
    } else if (diffInHours < 24) {
      return `${diffInHours}u geleden`;
    } else if (diffInDays < 7) {
      return `${diffInDays}d geleden`;
    } else {
      return messageDate.toLocaleTimeString('nl-NL', {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
      });
    }
  };

  const formatFullTime = (dateString: string) => {
    const messageDate = new Date(dateString);
    return messageDate.toLocaleString('nl-NL', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  };

  return (
    <div className={`flex justify-start ${isGrouped ? 'mb-1' : 'mb-4'}`}>
      <div className="flex max-w-xs lg:max-w-md min-w-0">
        {/* Icon */}
        <div className="flex-shrink-0 mr-2">
          <div className="w-8 h-8 rounded-full bg-white/[.06] border border-white/[.08] flex items-center justify-center">
            <Shield className="w-4 h-4 text-fg-faint" />
          </div>
        </div>

        {/* Message content */}
        <div className="flex flex-col min-w-0">
          {/* Suspended user label */}
          <div className="flex items-center gap-2 mb-1 ml-1">
            <span className="text-[11px] font-medium text-fg-meta">
              Geschorste gebruiker
            </span>
            <span
              className="text-[11px] text-fg-meta cursor-help"
              title={formatFullTime(timestamp)}
            >
              {formatTime(timestamp)}
            </span>
          </div>

          {/* Message bubble */}
          <div className="px-4 py-2.5 rounded-[16px] rounded-bl-[4px] bg-white/[.04] border border-white/[.08]">
            <div className="flex items-center gap-2 text-fg-muted">
              <Shield className="w-4 h-4 flex-shrink-0" />
              <p className="text-sm italic">
                Dit bericht is verborgen omdat de gebruiker is geschorst.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuspendedMessageBubble;